// BUILD-046 J1a: whether the task table currently has its "Customer" column (Compact, and customers in play for the page). The table header and every row read it
// here, from the same two stores, so a header and its cells can never disagree. The rule is customerColumnShown (customerDisplayModel.ts, tested).
import { useSyncExternalStore } from 'react';
import { density } from './densityStore';
import { associationColumnOf, customerColumnShown, customersInPlayStore } from './customerDisplayModel';
import type { AssociationColumn } from './customerDisplayModel';
import { jobsInPlayStore } from './jobDisplayModel';

export function useCustomerColumn(): boolean {
  const currentDensity = useSyncExternalStore(density.subscribe, density.get);
  const inPlay = useSyncExternalStore(customersInPlayStore.subscribe, customersInPlayStore.get);
  return customerColumnShown(currentDensity, inPlay);
}

/**
 * Whether the page is showing customers right now (the same store the table header and the Customer column read). The rows hand it to associationParts so that, while customers are in play, a row
 * that has a job and no customer writes "Job: <name>" instead of a bare name that would read as a customer (CHANGED 2026-10-25).
 */
export function useCustomersInPlay(): boolean {
  return useSyncExternalStore(customersInPlayStore.subscribe, customersInPlayStore.get);
}

/**
 * Which ONE association column the table has right now: 'customer' (customers in play; the cell also shows the row's job), 'job' (customers not in play: the original
 * "Customer / Job" column) or 'none'. The header and every row read this, from the same three stores, so a heading and its cells can never disagree and there are never two columns.
 */
export function useAssociationColumn(): AssociationColumn {
  const currentDensity = useSyncExternalStore(density.subscribe, density.get);
  const customers = useSyncExternalStore(customersInPlayStore.subscribe, customersInPlayStore.get);
  const jobs = useSyncExternalStore(jobsInPlayStore.subscribe, jobsInPlayStore.get);
  return associationColumnOf(currentDensity, customers, jobs);
}
